var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"wrap":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","pt-0":"","pb-0":""}},[_c('legal-page-template-card')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }